import {useEffect, useState} from "react";
import getSearchOptions from "../helpers/SearchOptions";

/**
 * Fetches autocomplete suggestions for each field in parallel.
 * Returns a record keyed by field name so callers can build their
 * own searchOptions array in a readable way.
 */
export const useSearchOptions = (url, fields, trackThisPromise = true) => {
  const [options, setOptions] = useState(() =>
    fields.reduce((acc, field) => {
      acc[field] = [];
      return acc;
    }, {})
  );

  useEffect(() => {
    const fetchAll = async () => {
      const results = await Promise.all(
        fields.map((field) => getSearchOptions(url, field, trackThisPromise))
      );
      setOptions(
        fields.reduce((acc, field, index) => {
          acc[field] = results[index] ?? [];
          return acc;
        }, {})
      );
    };
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return options;
};
